$(document).ready(function () {

    const locations = [];

    // De API geeft altijd de volledige lijst terug; één request per pagina is genoeg.
    // Gedeeld door alle zoekbalken, de dropdown en de Enter-afhandeling.
    let locationsRequest = null;
    function loadLocations() {
        if (!locationsRequest) {
            locationsRequest = Promise.resolve($.ajax({
                url: "/api/locations/get", // API-route
                method: "GET",
            })).then(function (data) {
                locations.push(...data);
                return locations;
            }).catch(function (error) {
                locationsRequest = null;
                throw error;
            });
        }
        return locationsRequest;
    }

    // "Dirk Boutsstraat 21" / "Kerkstraat 12a" -> { street, number }; anders null.
    // Herkent een straatnaam die eindigt op een huisnummer (met optionele toevoeging).
    function parseAddress(query) {
        const match = String(query).trim().match(/^(.+?)\s+(\d+.*)$/);
        if (!match) {
            return null;
        }
        return { street: match[1].trim().toLowerCase(), number: match[2].trim() };
    }

    function toTitleCase(str) {
        return str.replace(/\b\w/g, (char) => char.toUpperCase());
    }

    $(".js-searchbox").each(function(){
        const container = $(this);
        const selectedItems = [];
        const searchboxInput = container.find(".js-searchbox-input");
        const optionsContainer = container.find(".js-searchbox-options");
        const searchboxList = container.find(".js-searchbox-list");
        const noResults = container.find(".js-no-results");
        const selectedItemsContainer = container.find(".js-selected-items");
        const searchRadius = container.find(".js-search-radius");

    function renderOptions(filteredAreas) {
        searchboxList.empty();
        if (filteredAreas.length === 0) {
            noResults.show();
        } else {
            noResults.hide();
            filteredAreas.every((area, index) => {
                if (index === 10) {
                    return false;
                }
                const li = $("<li>")
                    .addClass("group flex w-full flex-col cursor-default flex-start rounded-md px-2 py-1.5 transition-colors hover:bg-gray-100 cursor-pointer")
                    .text(area.value)
                    .data("area", area);

                li.append('<span class="text-sm text-gray-400  group-hover:text-gray-500 capitalize">' + area.parent_label + '</span>');

                li.on("click", function () {
                    selectArea(area);
                    searchboxInput.val("");
                    renderOptions([]);
                });

                searchboxList.append(li);
                return true;
            });
        }
    }

    function selectArea(area) {
        if (!selectedItems.find((item) => item.value === area.value)) {
            selectedItems.push(area);
            renderSelectedItems();
            updateHiddenInput();
            toggleSearchRadius();
        }
    }

    function toggleSearchRadius() {
        if (selectedItems.length > 1 || selectedItems.find((item) => ['postcode', 'province'].includes(item.type))) {
            searchRadius.val(0);
            searchRadius.find('option').prop('selected', false);
            searchRadius.hide();
        } else {
            searchRadius.show();
        }
    }

    function removeSelectedItem(area) {
        const index = selectedItems.findIndex((item) => item.value === area.value);
        if (index !== -1) {
            selectedItems.splice(index, 1);
            renderSelectedItems();
            updateHiddenInput();
            toggleSearchRadius();

        }
    }

    function renderSelectedItems() {
        selectedItemsContainer.empty();
        selectedItems.forEach((item) => {
            const selectedItem = $("<span>")
                .addClass("bg-primary text-white px-3 py-1 rounded-lg text-sm flex items-center gap-2")
                .text(item.value);

            const removeButton = $("<button>")
                .addClass("text-red-600 hover:text-red-800")
                .html("&times;")
                .on("click", function () {
                    removeSelectedItem(item);
                });

            selectedItem.append(removeButton);
            selectedItemsContainer.append(selectedItem);
        });
        if (selectedItems.length > 0) {
            selectedItemsContainer.addClass('flex');
            selectedItemsContainer.removeClass('hidden');
        } else {
            selectedItemsContainer.removeClass('flex');
            selectedItemsContainer.addClass('hidden');
        }
    }

    function updateHiddenInput() {
        const selectedData = selectedItems.map((item) => {
            return `${item.value}|${item.type}`;
        }).join(',');
        $(".js-selected-areas-input").val(selectedData);
    }

    function debounce(func, wait) {
        let timeout;
        const debounced = function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
        debounced.cancel = () => clearTimeout(timeout);
        return debounced;
    }

    function filterLocations(query) {
        let filtered = locations.filter((area) => area.value.toLowerCase().includes(query));
        //also search in synonyms
        locations.forEach((area) => {
            if (area.synonyms) {
                area.synonyms.forEach((synonym) => {
                    //only add if not already in the list
                    if (filtered.find((a) => a.value === area.value)) {
                        return;
                    }
                    if (synonym.toLowerCase().includes(query)) {

                        filtered.push(area);
                    }
                });
            }
        });

        // Straatnaam + huisnummer: bied een expliciete adres-optie aan én houd de
        // bijbehorende straatsuggestie zichtbaar. Zonder dit verdwijnt elke suggestie
        // zodra het huisnummer wordt getypt (de gewone includes-match faalt dan).
        const parsed = parseAddress(query);
        if (parsed) {
            locations
                .filter((area) => area.type === 'street' && area.value.toLowerCase().includes(parsed.street))
                .forEach((area) => {
                    if (!filtered.find((a) => a.value === area.value)) {
                        filtered.push(area);
                    }
                });
            filtered.unshift({
                value: toTitleCase(query),
                type: 'address',
                parent_label: 'Zoek op dit adres',
            });
        }

        return filtered;
    }

    const debouncedFetchLocations = debounce(function (query) {
        loadLocations()
            .then(function () {
                renderOptions(filterLocations(query));
                optionsContainer.show();
            })
            .catch(function () {
                console.error("Error fetching locations");
            });
    }, 300);

    // Bepaal welke optie bij Enter hoort op basis van de actuele invoer, niet op basis
    // van de (mogelijk nog niet of verouderd) gerenderde dropdown. Wie snel typt en
    // direct op Enter drukt, krijgt zo hetzelfde resultaat als wie de suggesties afwacht.
    function resolveQuery(query) {
        const lowerQuery = query.toLowerCase();
        const exactMatch = locations.find((area) =>
            area.value.toLowerCase() === lowerQuery
            || (area.synonyms || []).some((synonym) => synonym.toLowerCase() === lowerQuery)
        );
        if (exactMatch) {
            return exactMatch;
        }
        const filtered = filterLocations(lowerQuery);
        if (filtered.length) {
            return filtered[0];
        }
        // Geen suggestie: "straatnaam + huisnummer" krijgt type 'address' zodat de API
        // op het specifieke adres matcht; overige vrije tekst blijft 'residence' (plaats).
        const parsed = parseAddress(query);
        return parsed
            ? { value: toTitleCase(query), type: 'address' }
            : { value: query.charAt(0).toUpperCase() + query.slice(1), type: 'residence' };
    }


    searchboxInput.on("input", function () {
        const query = $(this).val().toLowerCase();
        if (!query) {
            optionsContainer.hide();
            return;
        }
        debouncedFetchLocations(query);
    });
    // Voorkomt een dubbele submit bij herhaald Enter terwijl de lijst nog laadt.
    let enterPending = false;
    searchboxInput.on("keydown", function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
            const input = $(this);
            const form = input.closest("form");
            const query = input.val().trim();
            debouncedFetchLocations.cancel();
            if (enterPending) {
                return;
            }
            if (!query) {
                form.submit();
                return;
            }
            enterPending = true;
            const finish = function () {
                enterPending = false;
                selectArea(resolveQuery(query));
                input.val("");
                renderOptions([]);
                optionsContainer.hide();
                form.submit();
            };
            // Lijst nog niet binnen (snel getypt): eerst ophalen. Mislukt dat, dan
            // valt resolveQuery terug op de vrije-tekstafhandeling.
            loadLocations().then(finish, finish);
        }
    });

    $(document).on("click", function (e) {
        if (!$(e.target).closest(container).length) {
            optionsContainer.hide();
            searchboxInput.val("");
        }
    });

    function setSelectedAreasByQueryString() {
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        let selectedAreasParam = urlParams.get('selected_areas');
        let selectedAreas = selectedAreasParam ? decodeURIComponent(selectedAreasParam).split(',') : [];

        selectedAreas.forEach((area) => {
            const [value, type] = area.split('|');
            selectedItems.push({value, type});
        });
        let searchRadiusParam = urlParams.get('search_radius');
        if (searchRadiusParam) {
            searchRadius.val(searchRadiusParam);
        }

        updateHiddenInput();
        renderSelectedItems();
        toggleSearchRadius();
    }

    renderOptions([]); // Initialize with all options
    setSelectedAreasByQueryString();
  }); // end each .js-searchbox
});
